import { cn } from "@/lib/utils";

type HyperLinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  children: React.ReactNode;
  className?: string;
};

export default function Hyperlink({
  children,
  className,
  ...props
}: HyperLinkProps) {
  return (
    <a className={cn("text-primary hover:underline", className)} {...props}>
      {children}
    </a>
  );
}
